import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cb514a6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }

import { nextTick, markRaw } from 'vue'
import { ref } from 'vue-demi'
import Bus from '@/config/Bus'
import { Api } from '@/api/publicApi'
import { Api as ScreenSj } from '@/api/screenSj'
import DialogReservoir from '@/components/Dialog/DialogReservoir.vue'
import DialogDrinkingWater from '@/components/Dialog/DialogDrinkingWater.vue'
import DialogAutoMonitor from '@/components/Dialog/DialogAutoMonitor.vue'
import DialogManualMonitor from '@/components/Dialog/DialogManualMonitor.vue'
import DialogVideoInfo from '@/components/Dialog/DialogVideoInfoHK.vue'
import DialogTraceSource from '@/components/Dialog/DialogTraceSource.vue'
import DialogUVA from '@/components/Dialog/DialogUVA.vue'
import DialogYlz from '@/components/Dialog/DialogYlz.vue'
import modelDialog from '@/components/Dialog/modelDialog.vue'

import DialogDam from '@/components/Dialog/DialogDam.vue'
import DialogDike from '@/components/Dialog/DialogDike.vue'
import DialogPump from '@/components/Dialog/DialogPump.vue'
import DialogSupply from '@/components/Dialog/DialogSupply.vue'
import DialogBlowdown from '@/components/Dialog/DialogBlowdown.vue'
import DialogAquatic from '@/components/Dialog/DialogAquatic.vue'
import DialogHusbandry from '@/components/Dialog/DialogHusbandry.vue'
import DialogIndustrial from '@/components/Dialog/DialogIndustrial.vue'
import DialogProblemDisposal from '@/components/Dialog/DialogProblemDisposal.vue'
import DialogAgricultural from '@/components/Dialog/DialogAgricultural.vue'
import DialogRestaurant from '@/components/Dialog/DialogRestaurant.vue'
import DialogEnterprise from '@/components/Dialog/DialogEnterprise.vue'
import DialogPatrol from '@/components/Dialog/DialogPatrol.vue'
import DialogSewage from '@/components/Dialog/DialogSewage.vue'
import DialogDistributionStatistics from '@/components/Dialog/DialogDistributionStatistics.vue'
import SpecialAction from '@/components/Dialog/SpecialAction.vue'
import DialogPatrolDetails from '@/components/Dialog/DialogPatrolDetails.vue'
import DialogDiversionWater from '@/components/Dialog/DialogDiversionWater.vue'
import DialogRhpk from '@/components/Dialog/DialogRhpk.vue'
import DialogSubBasin from '@/components/Dialog/DialogSubBasin.vue'
import DialogSwz from '@/components/Dialog/DialogSwz.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Dialog',
  setup(__props) {

const api = new Api()
const screenApi = new ScreenSj()
const dialogVisible = ref(false)
const top: any = ref('35rem')
const data = ref({})
const isRequest = ref(false)
const currentDialog = ref('')
let modal = ''

function changeTab(newTab: string) {
  const lookup = {
    DialogReservoir,
    DialogDrinkingWater,
    DialogAutoMonitor,
    DialogManualMonitor,
    DialogVideoInfo,
    DialogTraceSource,
    DialogUVA,
    DialogYlz,
    DialogDam,
    DialogDike,
    DialogPump,
    DialogSupply,
    DialogBlowdown,
    DialogAquatic,
    DialogHusbandry,
    DialogIndustrial,
    DialogProblemDisposal,
    DialogAgricultural,
    DialogRestaurant,
    DialogEnterprise,
    DialogPatrol,
    DialogSewage,
    DialogDistributionStatistics,
    SpecialAction,
    DialogPatrolDetails,
    DialogDiversionWater,
    DialogRhpk,
    DialogSubBasin,
    DialogSwz,
    modelDialog,
    /* ...other component definitions */
  }
  currentDialog.value = newTab ? markRaw(lookup[newTab]) : null
}

Bus.on('showModal', (properties) => {
  console.log('on showModal', properties)
  open(properties)
})
Bus.on('showModal2', (ttop) => {})
Bus.on('showModal3', () => {
  console.log('查看模型')
  changeTab('modelDialog')
  dialogVisible.value = true
})

Bus.on('closeModal', () => {
  close()
})
const afterLeave = () => {
  changeTab('')
  modal = ''
  data.value = {}
  Bus.emit('onClose')
}
const open = async (properties) => {
  changeTab('')
  // if (Modal === undefined || Modal === true) {
  modal = properties.modalType
  // } else {
  //   modal.value = false
  // }
  if (properties.data) {
    try {
      properties.data = JSON.parse(properties.data)
    } catch (error) {
    } finally {
      await getData(properties.data)
    }
  }
}
const open2 = (ttop) => {
  top.value = ttop
  dialogVisible.value = true
}
const close = () => {
  Bus.emit('onModalClose', close) // 通知视频播放组件销毁插件
  dialogVisible.value = false
}
const getData = async (properties) => {
  let res = {}
  let error
  // if (this.isRequest) {
  //   currentDialog.value = '';
  //   return;
  // }
  try {
    isRequest.value = true
    switch (modal) {
      case 'gmhxmyz':
        await api.screen.getXmyzDetailUsingGet({ id: properties.id }).then((res2) => {
          if (res2.code === 200) {
            res = { ...res2.data, ...properties }
          } else {
          }
        })
        // res = await getXmyzDetailUsingGET({ id: properties.id })
        break
      case '自动监测断面':
        // res = await detailWithMnUsingGET({ id: properties.id })
        await api.screen.detailWithMnUsingPost({ id: properties.id }).then((res2) => {
          if (res2.code === 200) {
            res = { ...res2.data, ...properties }
            res.latitude = properties.wd
            res.longitude = properties.jd
          } else {
          }
        })
        break
      case 'scyz':
        await api.screen.getScyzDetailUsingGet({ id: properties.id }).then((res2) => {
          if (res2.code === 200) {
            res = { ...res2.data, ...properties }
          } else {
          }
        })
        // res = await getScyzDetailUsingGET({ id: properties.id })
        break
      case '手工监测断面':
        await api.screen.getSgMonitorInfoDetailUsingPost({ id: properties.id }).then((res2) => {
          if (res2.code === 200) {
            res = { ...res2.data, ...properties }
          } else {
          }
        })
        // res = await waterAssessmentByIdUsingGET({ id: properties.id })
        break
      case '饮用水源地':
        await api.screen.getYysMonitorInfoDetailUsingPost({ id: properties.id }).then((res2) => {
          if (res2.code === 200) {
            res = { ...res2.data }
          } else {
          }
        })
        break
      case '水库':
        // res = await getSkDetailUsingGET({ id: properties.id })
        await api.screen.skBasicInfoUsingPost({ id: properties.id }).then((res2) => {
          if (res2.code === 200) {
            res = { ...res2.data[0] }
          } else {
          }
        })
        break
      case 'hl':
        // res = await getRiverZLUsingGET({ id: properties.id })
        break
      case '水文站':
        res = { ...properties }
        // res = await getSwslDetailAndGraphUsingGET({ indexCode: properties.id })
        // await api.screen.getSwSiteDetailAndGraphUsingPost({ indexCode: properties.id }).then((res2) => {
        //   if (res2.code === 200) {
        //     res = { ...res2.data, ...properties }
        //   } else {
        //     return
        //   }
        // })
        console.log('水文站==========>');
        break
      case '污水处理厂':
        {
          let outPutCode = ''
          let outPuts = []
          if (properties.outPuts) {
            if (typeof properties.outPuts === 'string') {
              outPuts = JSON.parse(properties.outPuts)
            } else {
              outPuts = properties.outPuts
            }
          }
          if (properties.outPutCode) {
            outPutCode = properties.outPutCode
          } else if (outPuts[0]) {
            outPutCode = outPuts[0].outPutCode
          }
          console.log('污水处理厂信息', properties)
          //获取排口列表outPutCode
          await api.screen.wsclcOutPutListUsingPost({ id: properties.id }).then((res2) => {
            if (res2.code === 200) {
              console.log(res2)
              res = { outPuts: res2.data, ...properties }
              console.log(res)
            }
          })

          // res.outPuts = outPuts
          // res.properties = properties
        }
        break
      case 'xcsb':
      case 'zdgj':
      case 'rwjb':
       
        // res = await wgyWtInfoUsingGET_1({ id: properties.id });
        res = { id: properties.id }
        break
      case '分布统计':
        await api.screen.getWgyXhGridByZjUsingPost({ zj: properties.zj }).then((res2) => {
          if (res2.code === 200) {
            res = { tableData: res2.data }
          } else {
          }
        })
        break
      case '巡河记录':
        await api.screen
          .getGridXcRecordBaseInfoDtoUsingPost({ id: properties.itemId })
          .then((res2) => {
            if (res2.code === 200) {
              res = { ...res2.data }
            } else {
            }
          })
        break
      case '沿江排口':
      case '沿河排口':
      case 'pwk':
      case 'rhpk':
        res = { ...properties }
        break
      case '工业企业':
        console.log('properties', properties)
        await api.screen.getGyqyDetailUsingPost({ id: properties.id }).then((res2) => {
          if (res2.code === 200) {
            res = { ...res2.data }
          } else {
          }
        })
        break
      case '工业园区':
        await api.screen.getGyyqDetailByIdUsingPost({ id: properties.id }).then((res2) => {
          if (res2.code === 200) {
            res = { ...res2.data }
          } else {
          }
        })
        break
      case '专项行动':
        await api.screen.zxxdDetailUsingPost({ id: properties.id }).then((res2) => {
          if (res2.code === 200) {
            res = { ...res2.data, name: properties.name }
          } else {
          }
        })
        break
      default:
        break
    }
    if (res && !res.id) {
      res.id = properties.id
    }
    // this.data = res || {};
    // this.isRequest = false;
    await nextTick(() => {
      if (modal === '饮用水源地') {
        if (res.monitorType === '地表水') {
          changeTab('DialogSurfaceWater')
        } else {
          changeTab('DialogDrinkingWater')
        }
      } else {
        switch (modal) {
          case '测试':
            changeTab('DialogDistributionStatistics')
            // changeTab('DialogBlowdown')
            break
          case '污水处理厂':
            changeTab('DialogSewage')
            break
          case '自动监测断面':
            changeTab('DialogAutoMonitor')
            break
          case '手工监测断面':
            changeTab('DialogManualMonitor')
            break
          case 'gmhxmyz':
            changeTab('DialogHusbandry')
            break
            break
          case 'scyz':
            changeTab('DialogAquatic')
            break
          case '水库':
            changeTab('DialogReservoir')
            break
          case 'hl':
            changeTab('DialogTributary')
            break
          case '污染溯源':
            changeTab('DialogTraceSource')
            res = properties
            break
          case '无人机巡河':
            changeTab('DialogUVA')
            res = properties
            break
          case '水文站':
            // changeTab('DialogYlz')
            changeTab('DialogSwz')
            break
          case '河道视频监控':
            res = properties
            // √
            changeTab('DialogVideoInfo')
            break
          case '问题详情':
            changeTab('DialogProblemDisposal')
            break
          case 'yc':
            changeTab('DialogYC')
            break
          case '农贸市场':
            changeTab('DialogAgricultural')
            break
          case '餐饮企业':
            changeTab('DialogRestaurant')
            break
          case '巡河记录':
            changeTab('DialogPatrol')
            // res = properties
            // console.log(properties)
            break
          // case 'rhpk':
          //   changeTab('DialogRhpk')
          //   break
          case '沿江排口':
          case 'pwk':
          case '沿河排口':
            changeTab('DialogRhpk')
            // changeTab('DialogBlowdown')
            break
          case '分布统计':
            changeTab('DialogDistributionStatistics')
            break
          case '工业企业':
            changeTab('DialogEnterprise')
            break
          case '工业园区':
            changeTab('DialogIndustrial')
            break
          case '专项行动':
            changeTab('SpecialAction')
            break
          case '取水口':
            res = properties
            changeTab('DialogPump')
            break
          case '闸':
            changeTab('DialogDam')
            break
          case '堤防':
            changeTab('DialogDike')
            break
          case '供水厂':
            changeTab('DialogSupply')
            res = properties
            break
          case '子流域':
            changeTab('DialogSubBasin')
            res = properties
            break
          case '巡查详情':
            changeTab('DialogPatrolDetails')
            res = properties
          case '引调提水':
            changeTab('DialogDiversionWater')
          default:
            break
        }
      }
      if (Object.keys(res).length < 2) {
        data.value = properties
      } else {
        data.value = res || {}
      }
    })

    const ttop = getTop(properties.category)
    if (ttop) {
      top.value = ttop
    }
  } catch (e) {
    error = e
    dialogVisible.value = true
    // this.isRequest = false;
  }
  if (!error) {
    dialogVisible.value = true
  }
}
const getTop = (val) => {
  switch (val) {
    case 'wsclz':
      return '35rem' // 污水处理站
    case 'zl':
      return '18.95rem' // 支流
    case '水库':
      return '15rem' // 水库
    case 'scyz':
      return '39.6rem' // 水产养殖
    case '河道视频监控':
    case 'yc':
      return '16rem' // 视频监控
    case '无人机巡河':
      return '20rem' // 污染溯源
    case '污染溯源':
      return '12rem' // 污染溯源
    case 'xcsb':
    case 'zdgj':
    case 'rwjb':
      return '12rem' // 问题处置详情
    default:
      return '29rem'
  }
}
// 弹窗挂载完成的回调
const opened = () => {
  Bus.emit('openEnd')
}

return (_ctx: any,_cache: any) => {
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createBlock(_component_n_modal, {
    show: _unref(dialogVisible),
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_isRef(dialogVisible) ? (dialogVisible).value = $event : null)),
    class: "my-dialog",
    onOnAfterLeave: afterLeave
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_card, {
        style: {"width":"auto"},
        bordered: false,
        size: "huge",
        role: "dialog",
        "aria-modal": "true"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "close",
            onClick: close
          }, "×"),
          _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "default"),
            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentDialog)), {
              data: _unref(data),
              onGetData: getData,
              onOpen: open,
              onClose: close
            }, null, 40, ["data"]))
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})